import { specialistService } from "../_services";
import moment from 'moment'
moment.locale('ru')

let status = {
  INITIAL: 0,
  LOADING: 1,
  LOADED: 2
}

export default {
  namespaced: true,

  state: {
    updating: false,
    reestr: {
        list: [],
        status: status.INITIAL
    },
    types: {
        list: [],
        status: status.INITIAL
    },

    selectedType: null,
    selectedSort: 0,

    period: null,
  },
  getters: {
    reestr: ({ reestr }) => reestr.list,
    isReestrLoaded: ({ reestr }) => reestr.status == status.LOADED,
    types: ({ types }) => types.list,
    isTypesLoaded: ({ types }) => types.status == status.LOADED,
  },
  mutations: {
    setUpdating: (state, value) => {
      state.updating = value
    },
    setReestr: ({ reestr }, payload) => {
      reestr.list = payload
    },
    setReestrStatus: ({ reestr }, status) => {
      reestr.status = status
    },

    setTypes: ({ types }, payload) => {
      types.list = payload
    },
    setTypesStatus: ({ types }, status) => {
      types.status = status
    },

    selectType: (state, payload) => {
      state.selectedType = payload
    },

    selectSort: (state, payload) => {
      state.selectedSort = payload
    },

    setPeriod: (state, payload) => {
      state.period = payload
    },

    updateReestr: (state, r) => {
      if(state.reestr!=null) { 
        let curr = state.reestr.list.filter(item => item.id == r.id)[0]
        Object.assign(curr, r)
      }
    },
  },
  actions: {
    INIT: ({ dispatch }) => {
        dispatch('LOAD_REESTR')
    },
    LOAD_REESTR: ({ state, commit }) => {
//        if(state.reestr.status == status.INITIAL ){
           commit('setReestrStatus', status.LOADING)

           let start = moment().startOf('month').format('YYYY-MM-DD')
           let end = moment().endOf('month').format('YYYY-MM-DD')

           commit('setPeriod', { text: moment().format('MMMM YYYY'), type: 'month', start, end })

           specialistService.reestr(state.period.start, state.period.end).then(data => {
               commit('setReestr', data)
               commit('setReestrStatus', status.LOADED)

               let typeList=[] 
               data.forEach(d => {
                 typeList.find(j => j.value === d.specialistType.value) ? null : typeList.push(d.specialistType)
               })
               commit('setTypes', typeList)
               commit('setTypesStatus', status.LOADED)

           })
//        }
    },
    LOAD_REESTR_PERIOD: ({ state, commit }) => {
        specialistService.reestr(state.period.start, state.period.end).then(data => {
            commit('setReestr', data)
        })
    },
    SIGN: ({ commit }, id) => {
        return specialistService.signReestr( id )
        .then(data => {
          commit('updateReestr', data)
        })
    },

  }
}